@if (file.reason) {
  <div class="error" style="padding: 0.5rem">
    <div style="display: flex; align-items: flex-start">
      <div>
        <i class="fa-solid fa-circle-exclamation fa-xl"></i>
      </div>
      <div style="flex-grow: 1">
        <span>
          The file {{ file.file }} contains harmful content and couldn't be
          uploaded
        </span>
        <span class="warning" style="display: block">
          we recommend reaching out to your organization's security team for help
          with next steps
        </span>
      </div>
      <button
        data-testid="delete-contentpro-file-btn"
        class="btn btn-link delete action-icon"
        type="button"
        (click)="deleteFile()"
        aria-label="Delete file"
        >
        <i class="fa-solid fa-xmark fa-xl"></i>
      </button>
    </div>
  </div>
}

@if (!file.reason) {
  <div class="file-item {{ status }}">
    <div class="file-item-details">
      <i
        class="fa-solid file-type-icon"
        [ngClass]="getIconForFileType(file.file)"
        aria-hidden="true"
      ></i>
      <div class="uploaded-file-details">
        <span class="file-name">{{ file.file }}</span>
        <span class="file-size">{{ getSize(file.size) }}</span>
      </div>
    </div>
    <div class="action-buttons">
      <button
        data-testid="download-contentpro-file-btn"
        class="btn btn-link action-icon"
        type="button"
        (click)="downloadFile(file.id)"
        aria-label="Download file"
        >
        <i class="fa-solid fa-arrow-down-to-line"></i>
      </button>
      <button
        data-testid="delete-contentpro-file-btn"
        class="btn btn-link delete action-icon"
        type="button"
        (click)="deleteFile()"
        aria-label="Delete file"
        >
        <i class="fa-solid fa-trash-can"></i>
      </button>
    </div>
  </div>
}
<message-dialog [showAffirm]="false" class="delete-dialog" #deleteDialog>
  <div class="delete-dialog">
    <div
      class="btn close-dialog"
      data-testid="close-delete-dialog"
      (click)="closeDeleteDialog()"
      >
      <i class="fa-solid fa-xmark fa-xl"></i>
    </div>

    <div class="delete-dialog-header">
      <p>Are you sure you want to delete this file?</p>
    </div>
    <div class="message-dialog-body">
      <p>
        Are you sure you want to permanently delete the file "<strong>{{
        file.file
        }}</strong
        >"?
      </p>
    </div>
    <div class="delete-dialog-buttons">
      <button
        data-testid="cancel-delete-file-btn"
        class="btn cancel-delete"
        (click)="closeDeleteDialog()"
        i18n="Label for cancel button in delete file dialog"
        >
        Cancel
      </button>
      <button
        data-testid="confirm-delete-file-btn"
        class="btn btn-primary confirm-delete"
        (click)="confirmDeleteFile()"
        i18n="Label for confirm button in delete file dialog"
        >
        Delete
      </button>
    </div>
  </div>
</message-dialog>
<message-dialog #errorDialog></message-dialog>
